import { StyleSheet } from 'react-native';

export const homestyles = StyleSheet.create({
  top: {
    backgroundColor: '#f07e4e',
  },

  home: {
    marginHorizontal: 15,
    marginVertical: 20,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: 5,
  },
  rightSide: {
    flex: 1,
  },
  font1: {
    color: 'white',
    fontSize: 13,
  },
  font2: {
    fontSize: 16,
    fontWeight: 800,
  },
  down: {
    color: 'white',
    fontSize: 15,
  },
  user: {
    color: 'white',
    fontSize: 25,
  },
  inputSection: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    marginHorizontal: 10,
    marginTop: -6,
  },
  inputBox: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    padding: 10,
    backgroundColor: 'white',
    marginBottom: 10,
    width: '100%',
    borderRadius: 10,
  },

  input: {
    color: 'grey',
  },

  MenuChange: {
    fontSize: 25,
    color: 'white',
  },
});
